<template>
  <el-popover
    class="duplicate-candidate-popover"
    placement="right-start"
    width="300"
    trigger="click"
  >
    <DuplicateCandidate :duplicateCandidateList="duplicateCandidateList" @openDetail="openDetail"></DuplicateCandidate>
    <template #reference>
      <slot></slot>
    </template>
  </el-popover>
</template>

<script>
import DuplicateCandidate from './duplicateCandidate.vue'

export default {
  components: {
    DuplicateCandidate
  },
  props: {
    duplicateCandidateList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    openDetail (application) {
      this.$emit('openDuplicateCandidateDetail', application)
    }
  }
}
</script>
<style lang='scss' scoped>
.duplicate-candidate-popover {

}
</style>
